import { useState } from 'react';
import { Link } from 'react-router-dom';
import Layout from '@/components/feature/Layout';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SEOHead from '@/components/base/SEOHead';
import { categories, allArticles } from '@/mocks/siteData';

const categoryImageMap: Record<string, string> = {
  'lishi-qiyuan': 'https://readdy.ai/api/search-image?query=Ancient%20Japanese%20scroll%20and%20vintage%20film%20reels%20on%20wooden%20table%2C%20historical%20archival%20atmosphere%2C%20warm%20museum%20lighting%2C%20cultural%20heritage%20photography&width=800&height=500&seq=cat-hist-01&orientation=landscape',
  'leixing-fenlei': 'https://readdy.ai/api/search-image?query=Organized%20library%20shelves%20with%20categorized%20Japanese%20art%20books%20and%20catalogs%2C%20academic%20classification%20system%2C%20warm%20reading%20room%20light%2C%20scholarly%20photography&width=800&height=500&seq=cat-type-01&orientation=landscape',
  'wenhua-beijing': 'https://readdy.ai/api/search-image?query=Traditional%20Japanese%20temple%20gate%20with%20modern%20cityscape%20background%2C%20cultural%20fusion%20concept%2C%20warm%20sunset%20light%2C%20documentary%20photography&width=800&height=500&seq=cat-cult-01&orientation=landscape',
  'chanye-fenxi': 'https://readdy.ai/api/search-image?query=Modern%20Japanese%20media%20production%20office%20with%20computers%20and%20creative%20workspace%2C%20clean%20professional%20environment%2C%20soft%20office%20lighting%2C%20corporate%20photography&width=800&height=500&seq=cat-ind-01&orientation=landscape',
  'guankan-xuzhi': 'https://readdy.ai/api/search-image?query=Elegant%20home%20library%20with%20reading%20chair%20and%20warm%20lamp%20light%2C%20quiet%20study%20atmosphere%2C%20peaceful%20interior%20design%2C%20lifestyle%20photography&width=800&height=500&seq=cat-guide-01&orientation=landscape',
};

const articleImageMap: Record<string, string> = {
  'article-1': 'https://readdy.ai/api/search-image?query=Japanese%20animation%20studio%20workspace%20with%20drawing%20table%20and%20storyboard%20frames%20on%20wall%2C%20warm%20ambient%20lighting%2C%20professional%20anime%20production%20environment%2C%20clean%20and%20organized%2C%20editorial%20photography%20with%20soft%20shadows&width=600&height=375&seq=article-def-01&orientation=landscape',
  'article-2': 'https://readdy.ai/api/search-image?query=Retro%20Japanese%20VHS%20tape%20collection%20displayed%20on%20wooden%20shelves%20with%20vintage%20anime%20artwork%20covers%2C%201980s%20aesthetic%2C%20warm%20nostalgic%20lighting%2C%20cultural%20archival%20photography&width=600&height=375&seq=article-hist-01&orientation=landscape',
  'article-3': 'https://readdy.ai/api/search-image?query=Japanese%20Akihabara%20district%20with%20anime%20posters%20and%20electronics%20stores%2C%20urban%20cultural%20landscape%2C%20warm%20evening%20neon%20glow%2C%20documentary%20style%20photography%20with%20cinematic%20composition&width=600&height=375&seq=article-cult-01&orientation=landscape',
  'article-4': 'https://readdy.ai/api/search-image?query=Professional%20animation%20studio%20interior%20with%20digital%20drawing%20tablets%20and%20color%20scripts%20displayed%2C%20clean%20modern%20workspace%2C%20soft%20diffused%20lighting%2C%20editorial%20photography&width=600&height=375&seq=article-ind-01&orientation=landscape',
  'article-5': 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20home%20viewing%20setup%20with%20large%20monitor%20and%20comfortable%20lighting%2C%20clean%20aesthetic%20room%2C%20soft%20warm%20ambient%20light%2C%20editorial%20interior%20photography&width=600&height=375&seq=article-guide-01&orientation=landscape',
  'article-6': 'https://readdy.ai/api/search-image?query=Organized%20library%20of%20categorized%20Japanese%20animation%20art%20books%20on%20wooden%20shelves%2C%20academic%20setting%2C%20warm%20reading%20room%20lighting%2C%20scholarly%20atmosphere%20photography&width=600&height=375&seq=article-type-01&orientation=landscape',
  'article-7': 'https://readdy.ai/api/search-image?query=Modern%20digital%20content%20creation%20workspace%20with%20multiple%20screens%20displaying%20animation%20timeline%2C%20clean%20tech%20office%2C%20cool%20ambient%20lighting%2C%20professional%20technology%20photography&width=600&height=375&seq=article-dig-01&orientation=landscape',
  'article-8': 'https://readdy.ai/api/search-image?query=Japanese%20government%20building%20exterior%20with%20cherry%20blossom%20trees%2C%20formal%20institutional%20architecture%2C%20clear%20daylight%2C%20documentary%20architectural%20photography&width=600&height=375&seq=article-law-01&orientation=landscape',
  'article-9': 'https://readdy.ai/api/search-image?query=Calm%20and%20serene%20meditation%20space%20with%20soft%20natural%20light%20streaming%20through%20window%2C%20minimalist%20interior%20with%20plants%2C%20peaceful%20wellness%20atmosphere%2C%20editorial%20photography&width=600&height=375&seq=article-psy-01&orientation=landscape',
  'article-10': 'https://readdy.ai/api/search-image?query=Evolution%20of%20media%20formats%20displayed%20chronologically%20from%20VHS%20to%20Blu-ray%20to%20streaming%20icon%2C%20clean%20museum-style%20exhibition%2C%20soft%20gallery%20lighting%2C%20educational%20display%20photography&width=600&height=375&seq=article-media-01&orientation=landscape',
  'article-11': 'https://readdy.ai/api/search-image?query=Side%20by%20side%20comparison%20of%20two%20animation%20style%20boards%20on%20studio%20wall%2C%20professional%20art%20direction%20setting%2C%20clean%20studio%20lighting%2C%20editorial%20photography&width=600&height=375&seq=article-comp-01&orientation=landscape',
  'article-12': 'https://readdy.ai/api/search-image?query=International%20shipping%20and%20trade%20concept%20with%20world%20map%20and%20cultural%20exchange%20icons%2C%20clean%20corporate%20style%2C%20professional%20business%20photography%20with%20warm%20lighting&width=600&height=375&seq=article-glob-01&orientation=landscape',
  'article-13': 'https://readdy.ai/api/search-image?query=Official%20document%20and%20regulation%20books%20stacked%20on%20desk%20with%20reading%20lamp%2C%20legal%20research%20setting%2C%20warm%20library%20lighting%2C%20scholarly%20photography&width=600&height=375&seq=article-censor-01&orientation=landscape',
  'article-14': 'https://readdy.ai/api/search-image?query=Person%20reading%20and%20taking%20notes%20at%20a%20clean%20modern%20desk%20with%20laptop%2C%20educational%20self-improvement%20setting%2C%20soft%20natural%20light%2C%20editorial%20lifestyle%20photography&width=600&height=375&seq=article-lit-01&orientation=landscape',
};

export default function CategoriesPage() {
  const [activeCat, setActiveCat] = useState(categories[0].slug);
  const activeCategory = categories.find((c) => c.slug === activeCat) || categories[0];
  const filteredArticles = allArticles.filter((a) => a.categoryId === activeCat);

  return (
    <Layout>
      <SEOHead
        title="分类浏览 · 日本里番类型解析与观看须知"
        description="按历史起源、类型分类、文化背景、产业分析、观看须知五大维度系统浏览日本里番动画研究文章，帮助成年用户全面了解里番文化。"
        keywords="日本里番类型,里番分类,里番历史,成人动画分类,里番文化,里番产业"
        canonicalUrl="https://example.com/categories"
      />

      <section className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
        <div className="max-w-7xl mx-auto">
          <Breadcrumb items={[{ label: '首页', to: '/' }, { label: '分类浏览' }]} />

          <div className="mb-10">
            <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
              分类浏览
            </h1>
            <p className="text-foreground-500 text-sm max-w-2xl">
              选择下方分类标签，浏览不同维度的里番文化研究文章。每个分类包含多篇深度原创内容，帮助您建立系统性的知识框架。
            </p>
          </div>

          <div className="flex items-center gap-2 mb-10 overflow-x-auto pb-2 flex-wrap">
            {categories.map((cat) => (
              <button
                key={cat.id}
                onClick={() => setActiveCat(cat.slug)}
                className={`px-5 py-2.5 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                  activeCat === cat.slug
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-100 text-foreground-600 hover:bg-background-200 hover:text-foreground-800'
                }`}
              >
                {cat.name}
                <span className="ml-1.5 opacity-70 text-xs">({cat.articleCount})</span>
              </button>
            ))}
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            <div className="lg:col-span-1">
              <div className="bg-background-100 border border-background-200/70 rounded-lg overflow-hidden sticky top-24">
                <img
                  src={categoryImageMap[activeCategory.slug]}
                  alt={activeCategory.name}
                  className="w-full aspect-[16/10] object-cover"
                />
                <div className="p-5">
                  <h2 className="font-heading text-lg font-semibold text-foreground-900 mb-2">
                    {activeCategory.name}
                  </h2>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {activeCategory.description}
                  </p>
                  <div className="mt-4 pt-4 border-t border-background-200/70">
                    <div className="flex items-center gap-2 text-xs text-foreground-500">
                      <i className="ri-article-line"></i>
                      <span>共 {activeCategory.articleCount} 篇研究文章</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="lg:col-span-2">
              {filteredArticles.length > 0 ? (
                <div className="space-y-5">
                  {filteredArticles.map((article) => (
                    <Link
                      key={article.id}
                      to={`/articles/${article.slug}`}
                      className="group flex flex-col sm:flex-row gap-4 bg-background-50 border border-background-200/70 rounded-lg p-4 hover:border-primary-200/70 transition-all duration-300"
                    >
                      <div className="sm:w-48 flex-shrink-0 rounded-md overflow-hidden aspect-[16/10] sm:aspect-auto">
                        <img
                          src={articleImageMap[article.id]}
                          alt={article.title}
                          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                        />
                      </div>
                      <div className="flex-1 min-w-0">
                        <div className="flex items-center gap-3 mb-2">
                          <span className="text-xs text-primary-600 bg-primary-100 px-2.5 py-1 rounded-full">
                            {article.categoryName}
                          </span>
                          <span className="text-xs text-foreground-400">{article.readTime} 分钟阅读</span>
                          <span className="text-xs text-foreground-400">{article.date}</span>
                        </div>
                        <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                          {article.title}
                        </h3>
                        <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                          {article.excerpt}
                        </p>
                        <div className="flex items-center gap-2 mt-3 flex-wrap">
                          {article.tags.map((tag) => (
                            <span key={tag} className="text-xs text-foreground-400 bg-background-100 px-2 py-0.5 rounded">
                              #{tag}
                            </span>
                          ))}
                        </div>
                      </div>
                    </Link>
                  ))}
                </div>
              ) : (
                <div className="text-center py-16">
                  <i className="ri-inbox-line text-4xl text-foreground-300 mb-4 block"></i>
                  <p className="text-foreground-500">该分类暂无文章</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}